export function groupByMap(items, getIdField) {
  const dict = new Map();
  for (let i = 0; i < items.length; i++) {
    const item = items[i];
    const currentId = getIdField(item);
    const existing = dict.get(currentId);
    if (existing) {
      existing.push(items[i]);
    } else {
      dict.set(currentId, [items[i]]);
    }
  }
  return dict;
}

export default function groupBy(items, getIdField) {
  const dict = groupByMap(items, getIdField);
  return Array.from(dict.keys()).map((key) => ({ key, values: dict.get(key) }));
}
